'use client'
import { CookieNamesEnum } from '@/enums/CookieNamesEnum'
import { deleteCookie } from '@/helpers/deleteCookie'
import { deleteCookieAndNotify } from '@/hooks/useCookie'

export const clearImpersonationCookies = (): void => {
  deleteCookie(CookieNamesEnum.AsmSession)
  deleteCookie(CookieNamesEnum.SelectedOrgUnit)
  deleteCookieAndNotify(CookieNamesEnum.Site)
}
